import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonComponents } from 'src/app/Sharedservice/CommonComponents';
import { MatTabChangeEvent } from '@angular/material';
import { PatientBannerService } from 'src/app/patient-banner/patient-banner.service';
import { AESAlgorithm } from 'src/app/Utilities/Crypto/AESAlgorithm';

@Component({
  selector: 'app-visit-note',
  templateUrl: './visit-note.component.html',
  styleUrls: ['./visit-note.component.css']
})
export class VisitNoteComponent implements OnInit {
  // @Input() activetab=0;
  @Output() visitNote: EventEmitter<any> = new EventEmitter<any>();
  @Output() tabClicked = new EventEmitter<any>();
  encactivetab = 0;
  encounterId: string;
  constructor(//private app: AppComponent,
    private route: ActivatedRoute, private router: Router, private crypto: AESAlgorithm, private bannerService: PatientBannerService) {
    this.getSystem();
    //app.isLoggedIn$=true;
    this.bannerService.toggle(CommonComponents.patientId)
  }
  getSystem() {
    if (sessionStorage.getItem("encounterid") != null || sessionStorage.getItem("encounterid") != undefined) {
      CommonComponents.encounterId = sessionStorage.getItem("encounterid");
    }
    if (sessionStorage.getItem("patientId") != null || sessionStorage.getItem("patientId") != undefined) {
      CommonComponents.patientId = parseInt(sessionStorage.getItem("patientId"));
    }
  }
  ngOnInit() {

    if (localStorage.getItem("ordernoteheaderVisibility") == null)
      CommonComponents.headerVisibility = true;
    this.route.queryParams.subscribe(params => {
      this.encounterId = this.crypto.urlParmeterDecoder(decodeURIComponent(params['encounterId']));
      if (this.encounterId == '' || this.encounterId == undefined) {
        this.encounterId = sessionStorage.getItem("encounterid");
        CommonComponents.patientId = Number(sessionStorage.getItem("patientId"));
      }
      CommonComponents.encounterId = this.encounterId;
      sessionStorage.setItem("encounterid", CommonComponents.encounterId);
    });
    this.router.navigateByUrl('/Vitals');
    //this.visitNote.emit(CommonComponents.patientId);
    //this.bannerService.toggle(CommonComponents.patientId)
  }
  onLinkClick(event: MatTabChangeEvent) {

    event.tab.isActive = true;
    this.tabClicked.emit(event);
    this.router.navigateByUrl('/Visitnote/' + event.tab.textLabel);
  }

}
